var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "fragment",
    [
      !_vm.isExtranet && !_vm.isMobile
        ? _c("LoginWorldWide", {
            attrs: {
              username: _vm.username,
              label: _vm.label,
              logoutUrl: _vm.logoutUrl,
              myAccount: _vm.myAccount,
              myDataUrl: _vm.myDataUrl,
              state: _vm.state
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.state === "loggedIn" && !_vm.isExtranet
        ? _c("li", { staticClass: "hidden-xs" }, [
            _c("span", { staticClass: "space" })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isExtranet && !_vm.isMobile
        ? _c("LoginExtranet", {
            attrs: {
              firstName: _vm.firstName,
              lastName: _vm.lastName,
              label: _vm.label,
              logoutUrl: _vm.logoutUrl,
              loginUrl: _vm.loginUrl,
              myAccount: _vm.myAccount,
              registerUrl: _vm.extranetRegisterUrl,
              myDataUrl: _vm.extranetDataUrl,
              state: _vm.state
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isMobile
        ? _c("LoginMobile", {
            attrs: {
              isExtranet: _vm.isExtranet,
              firstName: _vm.firstName,
              username: _vm.username,
              lastName: _vm.lastName,
              label: _vm.label,
              logoutUrl: _vm.logoutUrl,
              loginUrl: _vm.loginUrl,
              myExtranetDataUrl: _vm.extranetDataUrl,
              myDataUrl: _vm.myDataUrl,
              state: _vm.state
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }